const TYPES_EQUIPEMENTS = [
  { value: 'imprimante', label: 'Imprimante' },
  { value: 'imprimante-code-barre', label: 'Imprimante code-barre' },
  { value: 'radio-echo', label: 'Radio/Echo' },
  { value: 'terminal-connecion', label: 'Terminal de connexion' },
  { value: 'armoire-medicale', label: 'Armoire médicale sécurisée' },
];

/** Types qui utilisent un champ IP classique */
export const TYPES_AVEC_IP = ['imprimante', 'imprimante-code-barre', 'radio-echo', 'terminal-connecion'];

/** Types qui ont une config Home Assistant étendue */
export const TYPES_HOME_ASSISTANT = ['armoire-medicale'];

export default TYPES_EQUIPEMENTS;
